export default __webpack_public_path__ + "static/media/BACnet-visual.5df77fa9.png";